module.exports = __webpack_public_path__ + "img/5743d2d256738e5f15535a21c44da86a.svg";